<template>
    <div>
        <field-wrapper
                label="Aviation rank"
                description="Estimated aviation impact of the event."
                :error="errors.aviation_ranks"
                option-label="label"
                v-model="values.aviation_ranks"
                track-by="value"
                :options="options.ranks"
                :multiple="true"
                :close-on-select="false"
                type="select"
        />
    </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import {FILTER_OPTIONS} from '@/app/wdc/form/fixtures'

  export default {
    components: {
      fieldWrapper
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'aviationRankFilter',
    data () {
      return {
        options: FILTER_OPTIONS
      }
    }
  }
</script>
<style>
</style>
